import { SmoLanguage } from '../../Models/Smo/SmoLanguage';
import { TesseractLanguage } from '../../Models/Tesseract/TesseractLanguage';
import { TextReaderLanguageConverter } from './TextReaderLanguageConverter';

export class TesseractTextReaderLanguageConverter implements TextReaderLanguageConverter<SmoLanguage> {
  public getTextReaderLanguageForGameLanguage(gameLanguage: SmoLanguage): string {
    switch (gameLanguage) {
      case SmoLanguage.english:
        return TesseractLanguage.english;
      case SmoLanguage.french:
        return TesseractLanguage.french;
      case SmoLanguage.chineseSimplified:
        return TesseractLanguage.chineseSimplified;
      case SmoLanguage.chineseTraditional:
        return TesseractLanguage.chineseTraditional;
    }
  }
}
